import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import fr from "./fr.json";

// The language is decided by the URL, not by a saved preference: every FR
// page lives at its plain path ("/", "/about", ...) and every EN page at
// the same path prefixed with "/en" ("/en", "/en/about", ...). Reading
// window.location.pathname here (at module load, before the app renders)
// means the very first render - including during build-time prerendering,
// where each route is loaded fresh in a headless browser - is already in
// the right language. No flash, no race condition with the prerender
// script capturing the page too early. See src/utils/languageRouting.js
// and the <LanguageSync> component in App.js, which keeps this in sync
// as the user navigates client-side between the two prefixes afterwards.
const initialLng =
  typeof window !== "undefined" && window.location.pathname.startsWith("/en")
    ? "en"
    : "fr";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
  },
  lng: initialLng,
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export default i18n;
